/**
 * @group Patient
 * @summary Patient domain exports
 * 
 * <blockquote>
 * Exports all patient domain components including constants, enums, models, types, relations, and repositories.
 * This provides a complete patient data model with proper domain boundaries and encapsulation.
 * </blockquote>
 * 
 * @example
 * ```typescript
 * import { 
 *   // Constants
 *   CONSULTATION_STATUS, 
 *   PAYMENT_METHOD_TYPE,
 *   // Enums
 *   consultationStatusEnum,
 *   paymentMethodTypeEnum,
 *   // Models
 *   consultations,
 *   patientProfiles,
 *   patientPaymentMethods,
 *   // Types
 *   Consultation,
 *   PatientProfile,
 *   PatientPaymentMethod,
 *   // Relations
 *   consultationRelations,
 *   patientProfileRelations,
 *   patientPaymentMethodRelations,
 *   // Repositories
 *   ConsultationRepository,
 *   PatientProfileRepository,
 *   PatientPaymentMethodRepository
 * } from '@shared/db';
 * ```
 */

// Constants
export * from './constants';

// Enums
export * from './enums';

// Models
export * from './models';

// Types
export * from './types';

// Relations
export * from './relations';

// Repositories
export * from './repositories';
